import type { AnyRoute } from '@tanstack/react-router'
import { i18n } from '../../shared/i18n/i18n'
import sv from './locales/sv.json'
import en from './locales/en.json'

i18n.addResourceBundle('sv', 'observationDays', sv, true, true)
i18n.addResourceBundle('en', 'observationDays', en, true, true)

// No pages yet: the bundle is registered here so the pages that follow find
// their texts the way every other feature's do.
/**
 * The älgobs day table, form and page have no routes of their own: Mitt jaktlag and
 * Säsonger mount them under theirs. This builder exists so the shell registers this
 * feature's strings the way it does every other feature's.
 */
export function buildObservationDaysRoutes<TParent extends AnyRoute>(_parent: TParent) {
  return []
}
